import { Title } from '@ui/components/title'
//import './servizi-modals.scss'

const Success = () => (
	<div className='servizi-modal'>
		<div className='servizi-modal__head'>
			<img src='assets/images/spunta.png' width={80} />
		</div>
		<Title>Questionario compilato correttamente</Title>
		<p>
			In base alle risposte fornite al questionario, la Polizza assicurativa
			proposta risulta coerente con le tue richieste ed esigenze.{' '}
		</p>
	</div>
)

export default Success
